// extracted by mini-css-extract-plugin
export var activityContainer = "_iq-0";
export var typingIndicatorContainer = "_iq-1";
export var typingIndicatorDot = "_iq-2";
export var wave = "_iq-3";